import { DocumentReference } from '@principle-theorem/shared';
import { IPatient } from './patient/patient';

export interface IPatientPhoneNumber {
  phoneNumber: string;
  patientRef: DocumentReference<IPatient>;
}
